import React, { useState, useEffect } from "react";
import { getDatabase, ref, onValue, remove, update } from "firebase/database";
import { toast } from "react-toastify";

const ProductList = () => {
    const [products, setProducts] = useState([]);
    const [editingProduct, setEditingProduct] = useState(null);
    const [editedName, setEditedName] = useState("");
    const [editedPrice, setEditedPrice] = useState("");
    const [editedDescription, setEditedDescription] = useState("");
    const [editedStatus, setEditedStatus] = useState(false);

    // Mengambil data produk dari Firebase
    useEffect(() => {
        const db = getDatabase();
        const productsRef = ref(db, "products");

        onValue(productsRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const productList = Object.keys(data).map((key) => ({
                    id: key,
                    ...data[key]
                }));
                setProducts(productList);
            } else {
                setProducts([]);
            }
        });
    }, []);

    // Menghapus produk
    const handleDelete = (id) => {
        const db = getDatabase();
        const productRef = ref(db, `products/${id}`); // Hapus berdasarkan ID produk

        remove(productRef)
            .then(() => {
                toast.success("Produk berhasil dihapus!");
                setProducts((prevProducts) =>
                    prevProducts.filter((product) => product.id !== id)
                );
            })
            .catch(() => toast.error("Gagal menghapus produk."));
    };

    // Memulai mode edit
    const startEdit = (product) => {
        setEditingProduct(product.id);
        setEditedName(product.name || "");
        setEditedPrice(product.price || "");
        setEditedDescription(product.description || "");
        setEditedStatus(product.status || false); // Tambahkan status
    };

    // Membatalkan edit
    const cancelEdit = () => {
        setEditingProduct(null);
        setEditedName("");
        setEditedPrice("");
        setEditedDescription("");
        setEditedStatus(false);
    };

    // Menyimpan perubahan
    const saveEdit = (id) => {
        const db = getDatabase();
        const productRef = ref(db, `products/${id}`);

        const originalProduct = products.find((p) => p.id === id);

        const updatedProduct = {
            name: editedName || originalProduct.name,
            price: editedPrice || originalProduct.price,
            description: editedDescription || originalProduct.description,
            images: originalProduct.images || [],
            status: editedStatus // Tambahkan status
        };

        update(productRef, updatedProduct)
            .then(() => {
                toast.success("Produk berhasil diperbarui!");
                cancelEdit();
            })
            .catch(() => toast.error("Gagal memperbarui produk."));
    };

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Daftar Produk</h1>

            {products.length === 0 ? (
                <p>Tidak ada produk.</p>
            ) : (
                <table className="table-auto w-full border-collapse border border-gray-300">
                    <thead>
                        <tr className="bg-gray-200">
                            <th className="border border-gray-300 p-2">
                                Gambar
                            </th>
                            <th className="border border-gray-300 p-2">Nama</th>
                            <th className="border border-gray-300 p-2">
                                Harga
                            </th>
                            <th className="border border-gray-300 p-2">
                                Deskripsi
                            </th>
                            <th className="border border-gray-300 p-2">
                                Status
                            </th>
                            <th className="border border-gray-300 p-2">Aksi</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products.map((product) => (
                            <tr
                                key={product.id}
                                className="border border-gray-300"
                            >
                                {editingProduct === product.id ? (
                                    // Mode Edit
                                    <>
                                        <td className="border border-gray-300 p-2">
                                            <img
                                                src={
                                                    product.images &&
                                                    product.images[0]
                                                        ? product.images[0]
                                                              .value
                                                        : "/default-image.jpg"
                                                }
                                                alt="Produk"
                                                className="w-16 h-16 rounded-md"
                                            />
                                        </td>
                                        <td className="border border-gray-300 p-2">
                                            <input
                                                type="text"
                                                value={editedName}
                                                onChange={(e) =>
                                                    setEditedName(
                                                        e.target.value
                                                    )
                                                }
                                                className="input input-bordered w-full"
                                            />
                                        </td>
                                        <td className="border border-gray-300 p-2">
                                            <input
                                                type="number"
                                                value={editedPrice}
                                                onChange={(e) =>
                                                    setEditedPrice(
                                                        e.target.value
                                                    )
                                                }
                                                className="input input-bordered w-full"
                                            />
                                        </td>
                                        <td className="border border-gray-300 p-2">
                                            <input
                                                type="text"
                                                value={editedDescription}
                                                onChange={(e) =>
                                                    setEditedDescription(
                                                        e.target.value
                                                    )
                                                }
                                                className="input input-bordered w-full"
                                            />
                                        </td>
                                        <td className="border border-gray-300 p-2">
                                            <input
                                                type="checkbox"
                                                checked={editedStatus}
                                                onChange={(e) =>
                                                    setEditedStatus(
                                                        e.target.checked
                                                    )
                                                }
                                                className="toggle"
                                            />
                                        </td>
                                        <td className="border border-gray-300 p-2">
                                            <button
                                                onClick={() =>
                                                    saveEdit(product.id)
                                                }
                                                className="btn btn-success btn-sm mr-2"
                                            >
                                                Simpan
                                            </button>
                                            <button
                                                onClick={cancelEdit}
                                                className="btn btn-warning btn-sm"
                                            >
                                                Batal
                                            </button>
                                        </td>
                                    </>
                                ) : (
                                    // Mode Tampilan
                                    <>
                                        <td className="border border-gray-300 p-2">
                                            <img
                                                src={
                                                    product.images &&
                                                    product.images[0]
                                                        ? product.images[0]
                                                              .value
                                                        : "/default-image.jpg"
                                                }
                                                alt="Produk"
                                                className="w-16 h-16 rounded-md"
                                            />
                                        </td>
                                        <td className="border border-gray-300 p-2">
                                            {product.name}
                                        </td>
                                        <td className="border border-gray-300 p-2">
                                            Rp{" "}
                                            {parseFloat(
                                                product.price
                                            ).toLocaleString("id-ID")}
                                        </td>
                                        <td className="border border-gray-300 p-2">
                                            {product.description}
                                        </td>
                                        <td className="border border-gray-300 p-2">
                                            <span
                                                className={`text-sm font-medium ${
                                                    product.status
                                                        ? "text-green-500"
                                                        : "text-red-500"
                                                }`}
                                            >
                                                {product.status
                                                    ? "Ready"
                                                    : "Not Ready"}
                                            </span>
                                        </td>
                                        <td className="border border-gray-300 p-2">
                                            <button
                                                onClick={() =>
                                                    startEdit(product)
                                                }
                                                className="btn btn-info btn-sm mr-2"
                                            >
                                                Edit
                                            </button>
                                            <button
                                                onClick={() =>
                                                    handleDelete(product.id)
                                                }
                                                className="btn btn-error btn-sm"
                                            >
                                                Hapus
                                            </button>
                                        </td>
                                    </>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default ProductList;
